import { Icon } from 'src/general/Icons/Icon';
import { FilterName } from 'src/plp/components/FilterName/FilterName';
import { FilterOption, PlpFilterItemProps } from '../PlpFilters.type';
import { FilterSelectItem } from '../components/Fields/FilterSelectItem';
import { FilterAccordion } from '../components/FilterAccordion/FilterAccordion';

export const FilterANCAP = ({
  options,
  value,
  index,
  showNotificationBadge,
  ...props
}: PlpFilterItemProps<FilterOption>) => {
  const id = 'ancapSafetyRating';
  const header = (
    <FilterName icon={<Icon name="ancap" />} label="ANCAP safety rating" showNotificationBadge={showNotificationBadge} />
  );
  const content = (
    <FilterSelectItem
      name="ancapSafetyRating"
      id="ancapSafetyRating"
      data-testid="ancapSafetyRating"
      options={options}
      size="small"
      defaultValue={value}
      {...props}
    />
  );

  return <FilterAccordion id={id} header={header} content={content} index={index} />;
};
